import { Theme, createStyles, makeStyles } from '@forgeglobal/design-framework';

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    primaryButton: {
      color: theme.palette.text.primary,
      '&:hover': {
        color: theme.palette.primary.main,
      },
    },
    desktopForm: {
      [theme.breakpoints.down('md')]: {
        display: 'none',
      },
    },
    wrapper: {
      padding: theme.spacing(1.5, 3),
    },
    content: {
      paddingTop: theme.spacing(3),
    },
    text: {
      marginBottom: theme.spacing(0.5),
      color: theme.palette.text.disabled,
    },
    buttons: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-end',
      flexWrap: 'wrap',
      marginTop: theme.spacing(1.5),
    },
  })
);
